import React from 'react';
import PropTypes from 'prop-types';
import MText from './Common/MText';
import Colours from '../styles/colours';

const LoyaltyMenuDescriptionBox = (props) => (
  <div
    style={{
      background:   props.background,
      border:       '1px solid black',
      borderRadius: 10,
      padding:      '12px 16px',
    }}
  >
    <MText bold={props.bold} text={props.text} style={{ lineHeight: props.lineHeight, textAlign: props.textAlign }} />
  </div>
);

LoyaltyMenuDescriptionBox.defaultProps = {
  background: Colours.LightGray2,
  bold:       true,
  lineHeight: 1.2,
  textAlign:  'center',
};

LoyaltyMenuDescriptionBox.propTypes = {
  text:       PropTypes.string.isRequired,
  background: PropTypes.string,
  textAlign:  PropTypes.string,
  lineHeight: PropTypes.number,
  bold:       PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
};

export default LoyaltyMenuDescriptionBox;
